import { ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material'

export type NavBarItemMatch = 'exact' | 'section'

interface Props {
  current: string
  icon: JSX.Element
  label: string
  match?: NavBarItemMatch
  value: string
  onClick: (label: string) => void
}
export function NavBarItem (props: Props): JSX.Element {
  const theme = useTheme()
  const normalize = (path: string): string => path.length > 1 ? path.replace(/\/$/, '').toLowerCase() : path.toLowerCase()
  const current = normalize(props.current)
  const value = normalize(props.value)
  const active = current === value || (props.match === 'section' && current.startsWith(`${value}/`))
  const color = active ? theme.palette.primary.main : '#595959'
  const backgroundColor = active ? theme.palette.primary.light : 'transparent'
  return (
    <ListItem data-testid='navBarItem' sx={{ color, backgroundColor, cursor: 'pointer' }} onClick={() => { props.onClick(props.value) }}>
      <ListItemIcon sx={{ color }}>
        {props.icon}
      </ListItemIcon>
      <ListItemText primary={props.label} />
    </ListItem>
  )
}
